/* BUUM Salespage V6 (12.10.2026, nach dem Meeting mit Richard) · Verhalten (Richards Funktionen im neuen Design).
   Ohne JavaScript funktionieren Bilder, Links, Faktenlage und Fragen; Countdown, Farbwahl,
   Galerie, Großansicht und die Leiste unten brauchen JavaScript. */
(function () {
  'use strict';

  /* ---------- Einstellungen ---------- */
  /* Countdown (V6, Entscheid 12.10.2026): zählt jeden Tag bis 24:00 Uhr Ortszeit des Besuchers
     und beginnt am nächsten Tag von vorne. EINE Quelle für Leiste oben, Paketbereich und Leiste unten. */

  /* Halterung Schwarz (V6): solange die schwarze Halterung nicht lieferbar ist, steht hier false.
     Dann ist die Auswahl „Halterung wählen“ ausgeblendet und alle Bilder und Kauflinks zeigen Edelstahl.
     >>> Sobald Schwarz lieferbar ist: auf true setzen – die Auswahl ist sofort wieder da (auch in Shopify). */
  var SCHWARZ_VERFUEGBAR = false;

  /* Kauflinks je Paket und Halterfarbe.
     >>> HIER die Produktadressen der zwei neuen Shop-Bundles eintragen (Bestseller-Set 79 €, Doppel-Set 99 €).
     Solange ein Feld leer ist, führt der Knopf nur zurück zur Paketauswahl – die Seite dann nicht live schalten. */
  var KAUFLINKS = {
    einsteiger: { edelstahl: '/cart/55997186703739:1', schwarz: '/cart/55997186703739:1' },  /* 39 € */
    bestseller: { edelstahl: '/cart/56321394213243:1', schwarz: '/cart/56321394213243:1' },  /* 58 € */
    doppel:     { edelstahl: '/cart/56323079012731:1', schwarz: '/cart/56323079012731:1' }   /* 99 € */
  };
  /* Diese Parameter aus der Seitenadresse werden an den Shop weitergegeben */
  var PARAMETER = /^(utm_|klar_|fa_|tblci$|fbclid$|gclid$)/;

  var doc = document, root = doc.documentElement;
  function alle(s, k) { return Array.prototype.slice.call((k || doc).querySelectorAll(s)); }
  var wenigBewegung = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = new URLSearchParams(location.search);
  /* Hüllen: als eigenständige Seite das <html>-Element, in Shopify jeder Block mit class="bm4" */
  var huellen = alle('.bm4'); if (!huellen.length) huellen = [root];

  /* ---------- Cookie-Einstellungen ----------
     In Shopify öffnet der Link die Einstellungen des Shopify-Cookie-Banners. Ohne Banner führt er zur Datenschutzerklärung. */
  alle('[data-cookie-einstellungen]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') { ev.preventDefault(); banner.showPreferences(); }
    });
  });

  /* ---------- Kauflinks und Farbwahl ---------- */
  var variante = 'edelstahl';
  function mitParametern(ziel) {
    try {
      var u = new URL(ziel, location.href);
      q.forEach(function (wert, name) {
        if (PARAMETER.test(name) && wert && !/[{}]|%7B|%7D/i.test(wert) && !u.searchParams.has(name)) u.searchParams.set(name, wert);
      });
      return u.toString();
    } catch (e) { return ziel; }
  }
  function linksSetzen() {
    var fehlend = [];
    alle('[data-kauf],[data-kauf-url]').forEach(function (a) {
      var id = a.getAttribute('data-kauf'), ziel = a.getAttribute('data-kauf-url') || (KAUFLINKS[id] || {})[variante];
      if (ziel) { a.href = mitParametern(ziel); a.rel = 'noopener'; }
      else { a.href = '#angebot'; a.removeAttribute('rel'); if (fehlend.indexOf(id) < 0) fehlend.push(id); }
    });
    if (fehlend.length && window.console) console.warn('Buum-Salespage: Kauflink fehlt für ' + fehlend.join(', '));
  }
  function varianteSetzen(v) {
    variante = v;
    alle('[data-variante]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-variante') === v ? 'true' : 'false'); });
    alle('[data-variante-label]').forEach(function (l) { l.textContent = v === 'schwarz' ? 'Schwarz' : 'Edelstahl'; });
    alle('img[data-edelstahl-src]').forEach(function (img) {
      if (img.hasAttribute('data-' + v + '-srcset')) img.srcset = img.getAttribute('data-' + v + '-srcset');
      img.src = img.getAttribute('data-' + v + '-src');
      img.alt = img.getAttribute('data-' + v + '-alt');
      if (img.hasAttribute('data-' + v + '-gross')) img.setAttribute('data-gross', img.getAttribute('data-' + v + '-gross'));
    });
    linksSetzen();
  }
  alle('[data-variante]').forEach(function (b) { b.addEventListener('click', function () { varianteSetzen(b.getAttribute('data-variante')); }); });
  alle('.farbwahl').forEach(function (f) { f.hidden = !SCHWARZ_VERFUEGBAR; });
  if (!SCHWARZ_VERFUEGBAR) varianteSetzen('edelstahl'); else linksSetzen();

  /* ---------- Countdown ---------- */
  var boxen = alle('[data-countdown-box]');
  function zwei(n) { return (n < 10 ? '0' : '') + n; }
  function mitternacht() { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
  function ticken() {
    var ende = mitternacht(), rest = ende - Date.now();
    if (!isFinite(ende) || rest <= 0) {
      boxen.forEach(function (b) { b.classList.remove('cd-an'); b.classList.add('cd-aus'); });
      return;
    }
    var stundenGesamt = Math.floor(rest / 3600000), lang = stundenGesamt > 99;
    var werte = lang
      ? { h: Math.floor(rest / 86400000), m: stundenGesamt % 24, s: Math.floor(rest / 60000) % 60 }
      : { h: stundenGesamt, m: Math.floor(rest / 60000) % 60, s: Math.floor(rest / 1000) % 60 };
    var namen = lang ? { h: 'Tage', m: 'Std', s: 'Min' } : { h: 'Std', m: 'Min', s: 'Sek' };
    alle('[data-cd]').forEach(function (f) { f.textContent = zwei(werte[f.getAttribute('data-cd')]); });
    alle('[data-cd-label]').forEach(function (f) { f.textContent = namen[f.getAttribute('data-cd-label')]; });
    alle('.countdown--klein').forEach(function (k) { k.classList.toggle('cd-lang', lang); });   /* Leiste unten: „19 Tg 12 Std“ statt „19:12:17“ */
    boxen.forEach(function (b) { b.classList.add('cd-an'); });
    setTimeout(ticken, 1000);
  }
  ticken();

  /* ---------- Mixed gallery: real Gradient application first, calm images afterwards ---------- */
  alle('[data-galerie]').forEach(function (g) {
    var bild=g.querySelector('[data-galerie-bild]'), film=g.querySelector('[data-galerie-film]');
    var buttons=alle('.hero__daumen button',g);
    buttons.forEach(function(k) { k.addEventListener('click',function() {
      var isVideo=k.hasAttribute('data-film-src');
      buttons.forEach(function(x) { x.setAttribute('aria-pressed',x===k?'true':'false'); });
      bild.hidden=isVideo; if(film) { film.hidden=!isVideo; if(!isVideo) film.pause(); }
      g.classList.toggle('ist-video',isVideo);
      var caption=g.querySelector('.hero__video-erklaerung'); if(caption) caption.hidden=!isVideo;
      if(isVideo) { if(film&&!wenigBewegung) { var play=film.play(); if(play&&play.catch) play.catch(function(){}); } }
      else { if (k.hasAttribute('data-srcset')) bild.srcset=k.getAttribute('data-srcset'); else bild.removeAttribute('srcset'); bild.src=k.getAttribute('data-src'); bild.alt=k.getAttribute('data-alt'); bild.setAttribute('data-gross',k.getAttribute('data-gross')); bild.setAttribute('aria-label',bild.alt+' – vergrößern'); }
    }); });
    /* Pfeile und Wischen auf dem Hauptbild: blättert durch Video und Bilder */
    var leiste=g.querySelector('.hero__daumen');
    function aktuell(){ for(var i=0;i<buttons.length;i++){ if(buttons[i].getAttribute('aria-pressed')==='true') return i; } return 0; }
    function schritt(r){
      if(buttons.length<2) return;
      var i=(aktuell()+r+buttons.length)%buttons.length, b=buttons[i]; b.click();
      if(leiste){ var ziel=b.parentNode.offsetLeft-(leiste.clientWidth-b.parentNode.offsetWidth)/2; leiste.scrollTo({left:Math.max(0,ziel),behavior:wenigBewegung?'auto':'smooth'}); }
    }
    alle('[data-galerie-schritt]',g).forEach(function(p){ p.addEventListener('click',function(ev){ ev.preventDefault(); ev.stopPropagation(); schritt(parseInt(p.getAttribute('data-galerie-schritt'),10)); }); });
    var haupt=g.querySelector('.hero__haupt'), sx=null, sy=0;
    if(haupt){
      haupt.addEventListener('touchstart',function(ev){ var t=ev.touches[0]; sx=t.clientX; sy=t.clientY; },{passive:true});
      haupt.addEventListener('touchend',function(ev){ if(sx===null) return; var t=ev.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy; sx=null; if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.2) schritt(dx<0?1:-1); },{passive:true});
    }
    var firstImage=buttons.filter(function(b){return b.hasAttribute('data-gross');})[0];
    if(firstImage) bild.setAttribute('data-gross',firstImage.getAttribute('data-gross'));
  });

  /* ---------- Lupe und Großansicht (Richards Lightbox) ---------- */
  alle('[data-zoom]').forEach(function (img) {
    var p = img.parentNode;
    if (p.querySelector('.zoom-hinweis')) return;
    var h = doc.createElement('span'); h.className = 'zoom-hinweis'; h.setAttribute('aria-hidden', 'true');
    h.innerHTML = '<svg viewBox="0 0 24 24"><use href="#i-lupe"/></svg>';
    p.appendChild(h);
    img.setAttribute('tabindex', '0'); img.setAttribute('role', 'button');
    img.setAttribute('aria-label', (img.alt || 'Bild') + ' – vergrößern');
  });
  var box = null, spur, punkte, zahl, anzahl = 0, zuletzt = null;
  function boxBauen() {
    if (box) return;
    box = doc.createElement('div'); box.className = 'grossansicht'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Bilder in Großansicht');
    box.innerHTML = '<span class="grossansicht__zahl"></span><button type="button" class="grossansicht__zu" aria-label="Schließen">✕</button>' +
      '<button type="button" class="grossansicht__nav grossansicht__nav--zurueck" data-gehe="-1" aria-label="Vorheriges Bild">‹</button>' +
      '<button type="button" class="grossansicht__nav grossansicht__nav--vor" data-gehe="1" aria-label="Nächstes Bild">›</button>' +
      '<div class="grossansicht__spur"></div><div class="grossansicht__punkte"></div>';
    var huelle = doc.createElement('div'); huelle.className = 'bm4'; huelle.appendChild(box); doc.body.appendChild(huelle);
    spur = box.querySelector('.grossansicht__spur'); punkte = box.querySelector('.grossansicht__punkte'); zahl = box.querySelector('.grossansicht__zahl');
    box.addEventListener('click', function (ev) {
      if (ev.target === box || ev.target.closest('.grossansicht__zu') || ev.target.tagName === 'FIGURE') { zu(); return; }
      var n = ev.target.closest('[data-gehe]'); if (n) gehe(parseInt(n.getAttribute('data-gehe'), 10));
    });
    spur.addEventListener('scroll', function () { markieren(Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth))); });
  }
  function markieren(i) {
    i = Math.max(0, Math.min(anzahl - 1, i));
    Array.prototype.forEach.call(punkte.children, function (p, k) { p.className = k === i ? 'an' : ''; });
    zahl.textContent = (i + 1) + ' / ' + anzahl;
  }
  function gehe(r) {
    var i = Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth)) + r;
    i = Math.max(0, Math.min(anzahl - 1, i));
    spur.scrollTo({ left: i * spur.clientWidth, behavior: wenigBewegung ? 'auto' : 'smooth' });
  }
  function quellen(img) {
    var eigene = img.getAttribute('data-bilder');
    if (eigene) return eigene.split('|').filter(Boolean).map(function (u) { return { src: u, alt: img.alt }; });
    if (!img.closest('[data-galerie]')) return [{ src: img.getAttribute('data-gross') || img.currentSrc || img.src, alt: img.alt }];
    var liste = [{ src: img.getAttribute('data-gross') || img.currentSrc || img.src, alt: img.alt }], gesehen = {};
    gesehen[liste[0].src] = 1;
    alle('.hero__daumen button').forEach(function (k) {
      var s = k.getAttribute('data-gross');
      if (s && !gesehen[s]) { gesehen[s] = 1; liste.push({ src: s, alt: k.getAttribute('data-alt') }); }
    });
    return liste;
  }
  function auf(img) {
    boxBauen(); zuletzt = img;
    var liste = quellen(img); anzahl = liste.length;
    spur.innerHTML = liste.map(function (b) { return '<figure><img src="' + b.src + '" alt="' + String(b.alt || '').replace(/"/g, '&quot;') + '"></figure>'; }).join('');
    punkte.innerHTML = liste.map(function () { return '<span></span>'; }).join('');
    box.hidden = false; root.style.overflow = 'hidden'; spur.scrollLeft = 0; markieren(0);
    box.querySelector('.grossansicht__zu').focus();
  }
  function zu() { if (!box || box.hidden) return; box.hidden = true; root.style.overflow = ''; if (zuletzt) zuletzt.focus(); }
  doc.addEventListener('click', function (ev) { var z = ev.target.closest && ev.target.closest('[data-zoom]'); if (z) { ev.preventDefault(); auf(z); } });
  doc.addEventListener('keydown', function (ev) {
    var z = ev.target.closest && ev.target.closest('[data-zoom]');
    if (z && (ev.key === 'Enter' || ev.key === ' ')) { ev.preventDefault(); auf(z); return; }
    if (!box || box.hidden) return;
    if (ev.key === 'Tab') {
      var focusables=alle('button:not([hidden])',box),first=focusables[0],last=focusables[focusables.length-1];
      if(ev.shiftKey&&doc.activeElement===first){ev.preventDefault();last.focus();}
      else if(!ev.shiftKey&&doc.activeElement===last){ev.preventDefault();first.focus();}
    }
    if (ev.key === 'Escape') zu(); else if (ev.key === 'ArrowLeft') gehe(-1); else if (ev.key === 'ArrowRight') gehe(1);
  });

  /* ---------- Inhaltsstoff-Slider ---------- */
  alle('[data-slider]').forEach(function (s) {
    var spurS = s.querySelector('[data-slider-spur]');
    alle('[data-slider-schritt]', s).forEach(function (b) {
      b.addEventListener('click', function () {
        spurS.scrollBy({ left: parseInt(b.getAttribute('data-slider-schritt'), 10) * Math.round(spurS.clientWidth * 0.75), behavior: wenigBewegung ? 'auto' : 'smooth' });
      });
    });
  });

  /* ---------- Anwendungsfilm: läuft stumm, sobald sichtbar ---------- */
  if (!wenigBewegung && 'IntersectionObserver' in window) {
    var filmWaechter = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && (!e.target._shouldAutoPlay || e.target._shouldAutoPlay())) { e.target.controls = true; var p = e.target.play(); if (p && p.catch) p.catch(function () { e.target.controls = true; }); }
        else if(e.target._autoPause) e.target._autoPause(); else e.target.pause();
      });
    }, { threshold: 0.35 });
    alle('video[data-film]').forEach(function (v) {
      var userPaused=false, automaticPause=false;
      v.addEventListener('pause',function(){if(!automaticPause&&!v.ended) userPaused=true;});
      v.addEventListener('play',function(){userPaused=false;});
      v._shouldAutoPlay=function(){return !userPaused&&!doc.hidden&&!v.hidden;};
      v._autoPause=function(){automaticPause=true;v.pause();setTimeout(function(){automaticPause=false;},0);};
      filmWaechter.observe(v);
    });
  }

  alle('[data-gruender-start]').forEach(function(button) {
    button.addEventListener('click',function(){
      var medium=button.parentNode, video=medium.querySelector('video');
      button.hidden=true; video.hidden=false; video.load(); video.focus();
      var play=video.play(); if(play&&play.catch) play.catch(function(){});
    });
  });
  doc.addEventListener('visibilitychange',function(){if(doc.hidden) alle('video').forEach(function(v){if(v._autoPause)v._autoPause();else v.pause();});});

  /* ---------- Leiste unten: an, sobald der Hero vorbei ist; aus über Paketen, Garantie und Footer ---------- */
  var leiste = doc.querySelector('[data-sticky]'), hero = doc.getElementById('hero');
  if (leiste && hero && 'IntersectionObserver' in window) {
    var vorbei = false, drin = [];
    function setzen() {
      var an = vorbei && drin.length === 0;
      leiste.classList.toggle('ist-sichtbar', an);
      leiste.setAttribute('aria-hidden', an ? 'false' : 'true');
      alle('a', leiste).forEach(function (a) { a.tabIndex = an ? 0 : -1; });
      huellen.forEach(function (h) { h.style.setProperty('--sticky-hoehe', an ? leiste.offsetHeight + 'px' : '0px'); });
    }
    new IntersectionObserver(function (es) { vorbei = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; setzen(); }, { rootMargin: '-60px 0px 0px 0px' }).observe(hero);
    var ausW = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var i = drin.indexOf(e.target); if (e.isIntersecting && i < 0) drin.push(e.target); if (!e.isIntersecting && i >= 0) drin.splice(i, 1); });
      setzen();
    }, { threshold: 0.08 });
    alle('[data-sticky-aus]').forEach(function (s) { ausW.observe(s); });
  }

  /* ---------- Sprung-Links (#angebot, #inhalt …) ----------
     Externe Scripts (z. B. Link-Ergänzung per GTM) schreiben Links in volle URLs mit Parametern um.
     Weichen die Parameter von der aktuellen Adresse ab, würde der Browser neu laden statt zu scrollen.
     Deshalb: Zeigt ein Link auf diese Seite und ein Ziel, das hier existiert, scrollen wir selbst. */
  doc.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target.closest && ev.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.hash.length < 2) return;
    var id = decodeURIComponent(u.hash.slice(1)), ziel = doc.getElementById(id);
    if (!ziel) return;
    ev.preventDefault();
    ziel.scrollIntoView({ behavior: wenigBewegung ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(history.state, '', location.pathname + location.search + '#' + id);
    if (id === 'inhalt') { ziel.setAttribute('tabindex', '-1'); ziel.focus({ preventScroll: true }); }
  });
})();
